import type { SVGProps } from "react";
import * as React from "react";

const WarningSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 0a11.998 11.998 0 0 0-8.485 20.485A12 12 0 0 0 24 12 12.01 12.01 0 0 0 12 0Zm0 3.013a1.714 1.714 0 0 1 1.714 1.715V12A1.714 1.714 0 0 1 12 13.715 1.714 1.714 0 0 1 10.286 12V4.728A1.714 1.714 0 0 1 12 3.013zm0 13.273A1.714 1.714 0 0 1 13.714 18v1.5A1.714 1.714 0 0 1 12 21.215a1.714 1.714 0 0 1-1.714-1.715V18A1.714 1.714 0 0 1 12 16.286z" />
  </svg>
);

export default WarningSVG;
